const mappingsTools = require('@/utils/mapTools')

const DATA_MAP = {
  ORG: [
    { label: 'School of Advanced Optoelectronics', value: '华南先进光电子研究院' },
    { label: 'School of Info &Opt science and engineering', value: '信息光电子科技学院' },
    { label: 'school of chemistry', value: '化学学院' },
    { label: 'school of computer science', value: '计算机学院' },
    { label: 'school of life sciences', value: '生命科学学院' },
    { label: 'college of bio-photonics', value: '生物光子学研究院' },
    { label: 'school of semiconductor science and technology', value: '半导体科学与技术学院' },
    { label: 'school of environment', value: '环境学院' },
    { label: 'school of physics and telecommunication engineering', value: '物理与电信工程学院' },
    { label: 'school of software', value: '软件学院' }
  ]

}
const v2Label = mappingsTools.key2Value(DATA_MAP) // 映射表数据处理

module.exports = {
  v2Label
}
